import React, { FC } from 'react';

import { ICollection, IMerchant } from 'src/prize/types/shoppe';

import { Banner } from './atoms/Banner';
import { Collections } from './molecules/Collections';
import Menu from './organisms/Menu';

interface HeaderProps {
  collection?: ICollection;
  collections?: ICollection[];
  merchant: IMerchant;
}

const Header: FC<HeaderProps> = ({ collection, collections, merchant }) => (
  <>
    <Menu merchant={merchant} />

    <Banner collection={collection} merchant={merchant} />

    {collections && collections.length > 0 && (
      <Collections activeCollectionId={collection?.id} data={collections} merchant={merchant} />
    )}
  </>
);

export default Header;
